import React from 'react';
import { Navigate } from 'react-router-dom';
import { USER_ROLES } from '../constants';

const ApplicationsRedirect = () => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));

    if (!currentUser) {
        return <Navigate to="/login" replace />;
    }

    const userRole = currentUser?.role?.name;

    // Map roles to URL-friendly position IDs
    const roleMap = {
        [USER_ROLES.ADMIN]: 'rn', // Admins default to RN forms but can switch
        [USER_ROLES.RN]: 'rn',
        [USER_ROLES.PT]: 'pt',
        [USER_ROLES.PTA]: 'pta',
        [USER_ROLES.OT]: 'ot',
        [USER_ROLES.OTA]: 'ota',
        [USER_ROLES.ST]: 'st',
        [USER_ROLES.MSW]: 'msw',
        [USER_ROLES.CG]: 'caregiver',
        [USER_ROLES.CNA]: 'cna',
        [USER_ROLES.HHA]: 'hha',
        [USER_ROLES.LVN]: 'lvn',
        [USER_ROLES.OA]: 'office-assistant',
        [USER_ROLES.SRVY]: 'srvy',
        [USER_ROLES.CON]: 'con'
    };

    const positionId = roleMap[userRole] || 'rn';

    return <Navigate to={`/applications/${positionId}`} replace />;
};

export default ApplicationsRedirect;
